function createThunkMiddleware(extraArgument) {
    return ({ dispatch, getState }) => next => action => {
      if (typeof action === 'function') {
        const _dispatch = (...params)=>{
            console.warn('It seems like you use dispatch function directly in effects. This in not recommend. Please be sue you this is nessissary.')
            dispatch(...params)
        }
        return action(_dispatch, getState, extraArgument);
      }
  
      return next(action);
    };
  }
  
  const thunk = createThunkMiddleware();
  thunk.withExtraArgument = createThunkMiddleware;
  
  export default thunk;